// @flow

/**
 * Utils for building Amplitude tracking payloads.
 */

import { MONEY_PAGE } from '../../../../lib/constants'
import store from '../../transfer/stores/configureStore'

export function getFeePayerTracking(): Object {
  const {
    transaction: { isPurchase, whoPaysFee },
    recipient: { moneyPageOverPanel },
  } = store.getState()
  if (
    moneyPageOverPanel === MONEY_PAGE.BUYER_FEES_REC_DEFAULT_WEB && // T10
    isPurchase
  ) {
    return {
      fee_payer: whoPaysFee === 'sellerPaysFee' ? 'payee' : 'payer',
    }
  }
  return {}
}
